import Http from "../http";

export const guestUserLoginAPI = (data) => {
  return Http.post("CampaignMember/login", data);
};

export const guestUserPhoneLoginAPI = (data) => {
  return Http.post("CampaignMember/phone-login", data);
};

export const getCurrentStepAPI = (data) => {
  return Http.post("api/member/current-step", data);
};

export const getMaterialAPI = (data) => {
  return Http.post("/api/member/getMaterial", data);
};
export const getTermsAndConditionsAPI = (data) => {
  return Http.post("api/member/terms-condition/get", data);
};

export const acceptTermsAndConditionsAPI = (data) => {
  return Http.post("api/member/terms-condition/accept", data);
};

export const getPaycheckIllustrationAPI = (data) => {
  return Http.post("api/member/paycheck-illustration", data ?? {});
};

export const getEnrollmentAPI = (data) => {
  return Http.post("api/member/get/enrollment-action", data);
};

export const acceptEnrollmentAPI = (data) => {
  return Http.post("api/member/accept/enrollment-action", data);
};
export const getEsignContentAPI = (data) => {
  return Http.post("api/enrollment-agreement/active", data);
};

export const acceptEsignAgreementAPI = (data) => {
  return Http.post("api/enrollment-agreement/accept", data);
};
export const nextStepAPI = (data) => {
  return Http.post("api/member/next-step", data);
};
export const getWelcomeAPI = (data) => {
  return Http.post("api/member/welcome-screen", data);
};

export const reviewBenefitsAPI = (data) => {
  return Http.post("api/member/review-benefits", data ?? {});
};